import { USER_LEVEL_KEY } from '~/api/interface'

/**
 * 处理权益状态判断
 * 只有管理员才能看到这个页面，所以省略购买权限判断
 */
export function useRightsInfo() {
  const userInfo = useUserInfo()

  // 当前登录用户的权益类型（转成 number，后台可能返回 string）
  const userRightsType = computed(() =>
    userInfo.value ? +userInfo.value.rights_type : 0
  )

  function isTrialAccount(rightsType: USER_LEVEL_KEY) {
    return [USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.TEAM_TASTE].includes(
      rightsType
    )
  }

  /** 试用版（个人 or 团队） */
  const isTrial = computed(() => isTrialAccount(userRightsType.value))

  /** 非企业(标准/旗舰)可(购买/续费)套餐 */
  const showPackageBuy = computed(
    () =>
      ![USER_LEVEL_KEY.ORG_STANDARD, USER_LEVEL_KEY.ORG_FLAGSHIP].includes(
        userRightsType.value
      )
  )

  /** 只有个人付费才显示言币加购 */
  const showCreditCoinBuy = computed(() =>
    [USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE].includes(
      userRightsType.value
    )
  )

  /** 只有个人付费、团队入门、企业才显示存储空间加购 */
  const showStorageBuy = computed(
    () =>
      ![USER_LEVEL_KEY.TEAM_LIGHT, USER_LEVEL_KEY.TEAM_TASTE].includes(
        userRightsType.value
      )
  )

  /** 要购买的套餐类型 */
  const buyRightsType = computed(() => {
    if (
      [USER_LEVEL_KEY.TEAM_TASTE, USER_LEVEL_KEY.TEAM_LIGHT].includes(
        userRightsType.value
      )
    ) {
      return USER_LEVEL_KEY.TEAM_LIGHT
    }

    if (
      userInfo.value?.rights_type &&
      [(USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.TEAM_TASTE)].includes(
        userInfo.value?.rights_type
      )
    ) {
      return userInfo.value?.rights_type
    }

    return USER_LEVEL_KEY.PERSONAL
  })

  return {
    userRightsType,
    isTrial,
    isTrialAccount,
    showPackageBuy,
    showCreditCoinBuy,
    showStorageBuy,
    buyRightsType,
  }
}
